/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestDataRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetInterestDataResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getInterestData = (request: GetInterestDataRequest, options?: CashRequestOptions) => post<GetInterestDataRequest, GetInterestDataResponse>("/2.0/cash/get-interest-data", request, {...options, rejectOnError: true })